import { type App } from 'vue';
import { registerPartial } from '@precon-tools-suite-by-shared/vue-partials';

// Export the composables that you want to use outside of this library.
export * from './composables/configurations';
export { default as routes } from './routes';

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartial(
            app,
            '@precon-tools-suite-by-shared/gino-risk-configurations-feature/partials/ChartPartial',
            () => import('./partials/ChartPartial.vue')
        );

        registerPartial(
            app,
            '@precon-tools-suite-by-shared/gino-risk-configurations-feature/partials/RiskInformationTable',
            () => import('./partials/RiskInformationTable.vue')
        );

        registerPartial(
            app,
            '@precon-tools-suite-by-shared/gino-risk-configurations-feature/partials/ThreatInformationTable',
            () => import('./partials/ThreatInformationTable.vue')
        );
    },
};
